// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var PersonStatus_Enum;
(function (PersonStatus_Enum) {
    PersonStatus_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    PersonStatus_Enum["ACTIVE"] = "ACTIVE";
    PersonStatus_Enum["INACTIVE"] = "INACTIVE";
    PersonStatus_Enum["NON_PATIENT"] = "NON_PATIENT";
    PersonStatus_Enum["ARCHIVED"] = "ARCHIVED";
    PersonStatus_Enum["PROSPECTIVE"] = "PROSPECTIVE";
    PersonStatus_Enum["DECEASED"] = "DECEASED";
})(PersonStatus_Enum || (PersonStatus_Enum = {}));
export var PersonStatus_Enum_index;
(function (PersonStatus_Enum_index) {
    PersonStatus_Enum_index[PersonStatus_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    PersonStatus_Enum_index[PersonStatus_Enum_index["ACTIVE"] = 1] = "ACTIVE";
    PersonStatus_Enum_index[PersonStatus_Enum_index["INACTIVE"] = 2] = "INACTIVE";
    PersonStatus_Enum_index[PersonStatus_Enum_index["NON_PATIENT"] = 3] = "NON_PATIENT";
    PersonStatus_Enum_index[PersonStatus_Enum_index["ARCHIVED"] = 4] = "ARCHIVED";
    PersonStatus_Enum_index[PersonStatus_Enum_index["PROSPECTIVE"] = 5] = "PROSPECTIVE";
    PersonStatus_Enum_index[PersonStatus_Enum_index["DECEASED"] = 6] = "DECEASED";
})(PersonStatus_Enum_index || (PersonStatus_Enum_index = {}));
export var PreferenceLanguage_Enum;
(function (PreferenceLanguage_Enum) {
    PreferenceLanguage_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    PreferenceLanguage_Enum["ENGLISH"] = "ENGLISH";
    PreferenceLanguage_Enum["SPANISH"] = "SPANISH";
    PreferenceLanguage_Enum["FRENCH"] = "FRENCH";
})(PreferenceLanguage_Enum || (PreferenceLanguage_Enum = {}));
export var PreferenceLanguage_Enum_index;
(function (PreferenceLanguage_Enum_index) {
    PreferenceLanguage_Enum_index[PreferenceLanguage_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    PreferenceLanguage_Enum_index[PreferenceLanguage_Enum_index["ENGLISH"] = 1] = "ENGLISH";
    PreferenceLanguage_Enum_index[PreferenceLanguage_Enum_index["SPANISH"] = 2] = "SPANISH";
    PreferenceLanguage_Enum_index[PreferenceLanguage_Enum_index["FRENCH"] = 3] = "FRENCH";
})(PreferenceLanguage_Enum_index || (PreferenceLanguage_Enum_index = {}));
export var PersonOrderBy_Enum;
(function (PersonOrderBy_Enum) {
    PersonOrderBy_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    PersonOrderBy_Enum["CREATED_AT"] = "CREATED_AT";
    PersonOrderBy_Enum["FIRST_NAME"] = "FIRST_NAME";
    PersonOrderBy_Enum["LAST_NAME"] = "LAST_NAME";
})(PersonOrderBy_Enum || (PersonOrderBy_Enum = {}));
export var PersonOrderBy_Enum_index;
(function (PersonOrderBy_Enum_index) {
    PersonOrderBy_Enum_index[PersonOrderBy_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    PersonOrderBy_Enum_index[PersonOrderBy_Enum_index["CREATED_AT"] = 1] = "CREATED_AT";
    PersonOrderBy_Enum_index[PersonOrderBy_Enum_index["FIRST_NAME"] = 2] = "FIRST_NAME";
    PersonOrderBy_Enum_index[PersonOrderBy_Enum_index["LAST_NAME"] = 3] = "LAST_NAME";
})(PersonOrderBy_Enum_index || (PersonOrderBy_Enum_index = {}));
export var ContactType_Enum;
(function (ContactType_Enum) {
    ContactType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    ContactType_Enum["PHONE_MOBILE"] = "PHONE_MOBILE";
    ContactType_Enum["PHONE_HOME"] = "PHONE_HOME";
    ContactType_Enum["PHONE_WORK"] = "PHONE_WORK";
    ContactType_Enum["EMAIL"] = "EMAIL";
})(ContactType_Enum || (ContactType_Enum = {}));
export var ContactType_Enum_index;
(function (ContactType_Enum_index) {
    ContactType_Enum_index[ContactType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ContactType_Enum_index[ContactType_Enum_index["PHONE_MOBILE"] = 1] = "PHONE_MOBILE";
    ContactType_Enum_index[ContactType_Enum_index["PHONE_HOME"] = 2] = "PHONE_HOME";
    ContactType_Enum_index[ContactType_Enum_index["PHONE_WORK"] = 3] = "PHONE_WORK";
    ContactType_Enum_index[ContactType_Enum_index["EMAIL"] = 4] = "EMAIL";
})(ContactType_Enum_index || (ContactType_Enum_index = {}));
